import { render, staticRenderFns } from "./coleccion.vue?vue&type=template&id=3f7856b2&"
import script from "./coleccion.vue?vue&type=script&lang=js&"
export * from "./coleccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports